import React from "react";
import PreviewPopoverLink from "../../PreviewPopover/PreviewPopoverLink";

export default class CustomerSection extends React.Component {
  constructor(props) {
    super(props);
  }

  guestsAllowed() {
    var options = [];
    if (
      this.props.reservation_segment.rate &&
      this.props.reservation_segment.rate.max_guests_allowed &&
      this.props.reservation_segment.rate.max_guests_allowed > 0
    ) {
      for (
        var i = 1;
        i <= this.props.reservation_segment.rate.max_guests_allowed;
        i++
      ) {
        options.push(
          <option key={i} value={i}>
            {i}
          </option>
        );
      }
    } else {
      options.push(
        <option key={this.props.reservation_segment.number_of_guests}>
          {this.props.reservation_segment.number_of_guests}
        </option>
      );
    }
    return options;
  }

  render() {
    return (
      <div className="CustomerSection">
        <div className="panel panel-default">
          <div className="panel-heading flexed">
            <div className="col-md-6 panel-title-wrapper">
              <h3 className="panel-title">{I18n.t("guest_details")}</h3>
            </div>
            {!this.props.read_only ? (
              <div className="col-md-6 flexed content-right button-wrapper">
                <button
                  type="button"
                  className={
                    "btn btn-primary btn-sm modal-iframe segment-card-action-button"
                  }
                  data-fullscreen="true"
                  data-nested="true"
                  href={`/admin/reservation_segments/${this.props.reservation_segment.id}/edit_guest_details`}
                >
                  <span className="ss-write">
                    <span className="edit-span">{I18n.t("edit")}</span>
                  </span>
                </button>
              </div>
            ) : null}
          </div>
          <div className="panel-body container">
            <div>
              <div className="row spacer">
                <div className="col-sm-6">
                  <label>
                    {I18n.t("checked_in_by")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("checked_in_by_helper_text")}
                    ></span>
                  </label>
                  {this.props.reservation_segment.status != "checked_in"
                    ? null
                    : this.renderResponsibleParty()}
                </div>
                <div className="col-sm-6">
                  <label>{I18n.t("booked_by")}</label>
                  {this.renderReservationCustomer()}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <label>{I18n.t("customers_staying_in_room")}</label>
                  {this.renderCustomers()}
                </div>
                <div className="col-md-6 form-group">
                  <label>{I18n.t('booking_phone_number')}</label>
                  <div>
                    {this.props.reservation.booking_phone_number}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReservationCustomer() {
    return (
      <div>
        <PreviewPopoverLink
          model_type="customer"
          model_id={
            this.props.reservation.customer
              ? this.props.reservation.customer.id
              : null
          }
          text={
            this.props.reservation.customer
              ? this.props.reservation.customer.full_name
              : ""
          }
        />
      </div>
    );
  }

  renderResponsibleParty() {
    return (
      <div>
        {this.props.reservation_segment.incidental_deposit_card_customer ? (
          <PreviewPopoverLink
            model_type="customer"
            model_id={
              this.props.reservation_segment.incidental_deposit_card_customer.id
            }
            text={
              this.props.reservation_segment.incidental_deposit_card_customer
                .full_name
            }
          />
        ) : (
          this.renderReservationCustomer()
        )}
      </div>
    );
  }

  renderCustomerList() {
    if (
      this.props.reservation_segment.customers &&
      this.props.reservation_segment.customers.length > 0
    ) {
      var customers = this.props.reservation_segment.customers.map(function (
        customer
      ) {
        return (
          <div key={customer.id}>
            {customer.full_name_email_address_city_and_state || customer.text}
          </div>
        );
      });

      return <div>{customers}</div>;
    } else {
      return <span className="none">{I18n.t("none")}</span>;
    }
  }

  renderCustomers() {
    var guests_in_room = this.props.reservation_segment.customers.map(
      (customer) => {
        return (
          <li key={customer.id}>
            <PreviewPopoverLink
              model_type="customer"
              model_id={customer.id}
              text={customer.first_name + customer.last_name}
            />
          </li>
        );
      }
    );

    return (
      <div>
        <div>
          {guests_in_room && guests_in_room.length ? (
            <ul>{guests_in_room}</ul>
          ) : (
            <span className="none">{I18n.t("none")}</span>
          )}
        </div>
      </div>
    );
  }
}
